module.exports = __webpack_public_path__ + "media/images/icons/vk_black-7e3a489e27a2ad336c8a0133c866c362.svg";